import {BaseService} from "./base";

class SystemService extends BaseService {
  constructor() {
    super();
  }

  /**
   * 急救用户登录验证码
   * @param mobile
   * @param sysUserType [AID_ADM]
   * @returns {Promise<boolean>}
   */
  async captchaEmergency(mobile, sysUserType) {
    const {code, obj} = await this.$http('nethos.system.captcha.emergency.staffing.login', {
      mobile,
      sysUserType
    });
    return code === '0' ? obj : {};
  }


  /**
   *
   * @param docType
   * @param pageSize
   * @param pageNum
   * @param searchString
   * @param hosId
   * @returns {Promise<{list: *, paginator: *}>}
   */
  async listDoc({docType, searchString, hosId, pageSize = 10, pageNum = 1}) {
    const {list} = await this.$http('nethos.doc.simple.list', {
      docType, pageNum, pageSize, searchString, hosId
    });
    return {list};
  }

  /**
   *
   * @returns {Promise<[]>}
   */
  async listHos(hosId) {
    const {list = []} = await this.$http('nethos.consult.group.hos.list', {
      hosId,
      moduleType: 'EMERGENCY'
    });
    return list
  }

  /**
   * 上报推送id
   * @param deviceId
   * @returns {Promise<void>}
   */
  async deviceid(deviceId) {
    await this.$http('nethos.push.deviceid.register', {
      deviceId
    })
  }

  /**
   *
   * @returns {Promise<*>}
   */
  async data() {
    const {code, obj} = await this.$http('nethos.demo.area.count', {});
    return code === '0' ? obj : {};
  }

  /**
   * 系统参数
   * @param key
   * @param defaultString
   * @returns {Promise<T.obj>}
   */
  async xtcs(key, defaultString) {
    const {code, obj} = await this.$http('nethos.system.param.string', {
      defaultString,
      key
    });
    return code === '0' ? obj : defaultString;
  }
}

export const systemService = new SystemService();
